import React, { Component } from 'react';
import { Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import ChannelVisibilityContainer from 'containers/dashboards/siteDirect/ChannelVisibilityContainer';
import { generateCalloutComponents } from 'helpers/componentGenerators';
import GenericSiteDirectExpandContainer from 'containers/dashboards/siteDirect/GenericSiteDirectExpandContainer';
import { getActivitiesSettings } from 'helpers/objectiveSettings';

class GenericSiteDirectModule extends Component {
    render() {
        const { channel, ioChannel } = this.props;
        const stub = `l3-site-${ioChannel}`;
        const { entityObjective } = this.props;
        const {
            eCPAActivitiesOrClicks, showActivitiesData, calloutTitle
        } = getActivitiesSettings(entityObjective);
        const hasCalloutData = get(this.props, 'channel.callouts.params.hasData', false);
        const callouts = get(this.props, 'channel.callouts.data', {});
        const calloutWindow = get(this.props, 'channel.callouts.params.timeRanges.previous.windowSize', null);
        const calloutSettings = [
            { key: 'impressions', title: 'Impressions', format: '0,0' },
            { key: eCPAActivitiesOrClicks, title: calloutTitle, format: '0,0' },
            showActivitiesData ? { key: 'ecpa', title: 'Average eCPA', format: '$0,0.00' } : { key: 'ctr', title: 'CTR', format: '0.00%' },
        ];
        const calloutComponents = generateCalloutComponents({
            stub, calloutSettings, hasCalloutData, callouts, calloutWindow
        });

        return (
            <ChannelVisibilityContainer ioChannel={ioChannel} channel={channel}
                expandContainer={GenericSiteDirectExpandContainer}>
                {/* Call Outs */}
                <Row>
                    {calloutComponents}
                </Row>


            </ChannelVisibilityContainer>
        );
    }
}

GenericSiteDirectModule.propTypes = {
    channel: PropTypes.object,
    ioChannel: PropTypes.string
};


export default GenericSiteDirectModule;



// WEBPACK FOOTER //
// ./src/components/organisms/siteDirect/GenericSiteDirectModule.js